module.exports = __webpack_public_path__ + "static/hom-web-2942e5d9264cebc50091a59a7d83dc92.jpg";